/**
 * FeedbackStatsPanel.jsx — 결과유형별 콜 통계 카드(가로 막대 차트 + 요약 테이블)
 *
 * TmSummary.jsx 에서 분리(300줄 규칙). 렌더 결과·동작은 분리 전과 동일합니다.
 * 로딩·데이터 없음 상태도 이 컴포넌트가 담당합니다.
 */
import React from 'react';
import HorizontalBarChart from './HorizontalBarChart';
import { BAR_COLORS, CARD, TH, TD } from './utils';

export default function FeedbackStatsPanel({ stats, total, selectedFeedback, onSelect, loading, isMobile }) {
  if (loading) {
    return (
      <div style={{ ...CARD, textAlign: 'center', padding: '40px 20px', color: 'var(--text-muted)', fontSize: 14 }}>불러오는 중...</div>
    );
  }
  if (stats.length === 0) {
    return (
      <div style={{ ...CARD, textAlign: 'center', padding: '40px 20px', color: 'var(--text-muted)', fontSize: 14 }}>해당 기간에 콜 데이터가 없습니다.</div>
    );
  }

  return (
    <div style={{ ...CARD, padding: isMobile ? '12px 14px' : '16px 20px', overflow: 'hidden' }}>
      <div style={{ fontSize: 11, color: 'var(--text-muted)', marginBottom: 12 }}>항목을 클릭하면 해당 콜 목록을 확인할 수 있습니다.</div>
      <div style={{ display: 'flex', gap: isMobile ? 16 : 32, flexDirection: isMobile ? 'column' : 'row', alignItems: 'flex-start' }}>
        <div style={{ flex: '1 1 auto', width: '100%' }}>
          <HorizontalBarChart stats={stats} total={total} selectedFeedback={selectedFeedback} onSelect={onSelect} isMobile={isMobile} />
        </div>
        {/* 요약 테이블 — 모바일에서는 차트가 이미 건수/비율 표시 */}
        {!isMobile && (
          <div style={{ flex: '0 0 auto' }}>
            <table style={{ borderCollapse: 'collapse', minWidth: 210 }}>
              <thead>
                <tr>
                  <th style={TH}>결과 유형</th>
                  <th style={{ ...TH, textAlign: 'right' }}>건수</th>
                  <th style={{ ...TH, textAlign: 'right' }}>비율</th>
                </tr>
              </thead>
              <tbody>
                {stats.map((item, idx) => {
                  const pct        = total > 0 ? Math.round((item.count / total) * 100) : 0;
                  const isSelected = selectedFeedback === item.feedback;
                  return (
                    <tr
                      key={item.feedback}
                      onClick={() => onSelect(item.feedback)}
                      style={{ cursor: 'pointer', background: isSelected ? 'rgba(37,99,235,0.08)' : 'transparent' }}
                    >
                      <td style={{ ...TD, fontWeight: isSelected ? 700 : 400, color: isSelected ? '#2563eb' : 'var(--text-sub)' }}>
                        <span style={{ display: 'inline-block', width: 8, height: 8, borderRadius: '50%', background: BAR_COLORS[idx % BAR_COLORS.length], marginRight: 7, verticalAlign: 'middle' }} />
                        {item.feedback}
                      </td>
                      <td style={{ ...TD, textAlign: 'right', fontWeight: isSelected ? 700 : 500, color: isSelected ? '#2563eb' : 'var(--text-sub)' }}>{item.count}건</td>
                      <td style={{ ...TD, textAlign: 'right', color: 'var(--text-muted)' }}>{pct}%</td>
                    </tr>
                  );
                })}
                <tr style={{ borderTop: '1.5px solid var(--border)' }}>
                  <td style={{ ...TD, fontWeight: 700, color: 'var(--text)', borderBottom: 'none' }}>합계</td>
                  <td style={{ ...TD, textAlign: 'right', fontWeight: 700, color: 'var(--text)', borderBottom: 'none' }}>{total}건</td>
                  <td style={{ ...TD, textAlign: 'right', color: 'var(--text-muted)', borderBottom: 'none' }}>100%</td>
                </tr>
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}
